import { FAIcon } from 'shared'

const PaymentCardItem = ({ card, cardsDidUpdate }) => {
  const removeCard = async () => {
    let result = await Backend.destroy(`/profile/credit_cards/${card.id}`)
    cardsDidUpdate(result.cards)
  }

  const activateCard = async () => {
    let result = await Backend.post(`/profile/credit_cards/${card.id}/activate`)
    cardsDidUpdate(result.cards)
  }

  let cardIcon = CardBrandToIconMapping[card.brand.toLowerCase()] || 'faCreditCard'
  return (
    <div className="credit-card my-3">
      <div className={classNames("credit-card-info", {inactive: !card.is_primary})}>
        <FAIcon icon={cardIcon} className='credit-card-brand-icon' size='lg'/>{card.brand} ending in <b>{card.last_4}</b>
      </div>
      <div className="credit-card-expiration">
        exp {card.exp_month}/{card.exp_year}
      </div>
      <div className="credit-card-actions">
        {
          !card.is_primary && <button className="btn btn-sm smart-button" onClick={activateCard}>Make Primary</button>
        }
        <button className="btn btn-sm btn-danger smart-button" onClick={removeCard}>Remove</button>
      </div>
    </div>
  )
}

const CardBrandToIconMapping = {
  visa: 'faCcVisa',
  mastercard: 'faCcMastercard',
  discover: 'faCcDiscover',
  jcb: 'faCcJcb',
}

export default PaymentCardItem
